// Plain-English descriptions of each roster tier, written for members rather
// than staff. Shown on the public sign-up form (JoinView) so someone joining
// can place themselves without knowing our internal naming. Edit the wording
// here and it updates everywhere the form shows it.
export const TIER_DESCRIPTIONS = {
  "Junior Mini (Pickleball)": "Ages 6 & under — a fun-first introduction on the pickleball courts.",
  "Junior Beginner": "New to tennis; learning grip, contact and first rallies.",
  "Junior Intermediate": "Rallies consistently and plays points.",
  "Junior Advanced": "Competitive juniors playing at tournament level.",
  "Adult Beginner": "New to tennis, or coming back after years off.",
  "Adult Intermediate": "Sustains rallies and is comfortable in doubles (around 3.0–3.5).",
  "Adult Adv Intermediate": "Reliable serve and match strategy (around 3.5–4.0).",
  "Adult Advanced / Elite": "Strong all-court game; league and tournament play (4.0+).",
  "No Group": "Not sure yet — a coach will assess and place you.",
};

// The tiers offered on the sign-up form, split by classification so a junior
// is never shown adult groups and vice versa. "No Group" is offered to both
// as the explicit "I'm not sure" answer.
export const JUNIOR_SIGNUP_TIERS = [
  "Junior Mini (Pickleball)",
  "Junior Beginner",
  "Junior Intermediate",
  "Junior Advanced",
  "No Group",
];

export const ADULT_SIGNUP_TIERS = [
  "Adult Beginner",
  "Adult Intermediate",
  "Adult Adv Intermediate",
  "Adult Advanced / Elite",
  "No Group",
];

export function signupTiersFor(classification) {
  return classification === "Junior" ? JUNIOR_SIGNUP_TIERS : ADULT_SIGNUP_TIERS;
}

// Label shown for "No Group" on the form — the internal name reads like an
// error to someone signing up.
export function tierLabel(tier) {
  return tier === "No Group" ? "I'm not sure — please place me" : tier;
}
